<div class="tab-list-header">
    <div class="content-wrapper">
        <a
            class="tab-list-item active"
            [class.active]="isActiveTab(UPCOMING)"
            [routerLink]="[upcomingLink]"
        >
            <span>{{ "APPOINTMENT-OVERVIEW.TAB.UPCOMING" | translate }}</span>
        </a>
        <a
            class="tab-list-item"
            [class.active]="isActiveTab(HISTORY)"
            [routerLink]="[historyLink]"
        >
            <span>{{ "APPOINTMENT-OVERVIEW.TAB.HISTORY" | translate }}</span>
        </a>
        <a
            class="tab-list-item"
            [class.active]="isActiveTab(CANCELED)"
            [routerLink]="[canceledLink]"
        >
            <span>{{ "APPOINTMENT-OVERVIEW.TAB.CANCELED" | translate }}</span>
        </a>
    </div>
</div>
<router-outlet></router-outlet>
